<div [ngClass]="{'is-loading': showSpinner}">
  <div>
    <div class="btn-group btn-group-toggle" data-toggle="buttons">
      <label class="btn btn-secondary active" (click)="tab_AEOrIgnored = 'ae'">
        <input type="radio" name="options" id="option1" autocomplete="off" checked>
        Aggregations & Exceptions
      </label>
      <label class="btn btn-secondary" (click)="tab_AEOrIgnored = 'ignored'">
        <input type="radio" name="options" id="option3" autocomplete="off">
        Ignored Exceptions
      </label>
  </div>
  <div class="row float-right">
    <h5 class="mt-1 mr-2" *ngIf="clientId">Client ID: {{clientId}}</h5>
    <div class="d-inline-block mr-2" ngbDropdown #myDrop="ngbDropdown"
      *ngIf="sharedDataService.relatedClients?.length > 1">
      <button class="btn btn-sm btn-primary" id="dropdownManual" ngbDropdownAnchor (focus)="myDrop.open()">Related Client Aggregations</button>
      <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownManual">
        <button ngbDropdownItem *ngFor="let item of sharedDataService.relatedClientFilterSelected(clientId)" (click)="CallParentClientChange(item.clientId)">
          {{item.type}} -- {{item.clientId}}
        </button>
      </div>
    </div>
  </div>
  <!-- Aggregations -->
  <div *ngIf="tab_AEOrIgnored == 'ae'" class="detail-table-container">
    <h6 class="card-header">Aggregations</h6>
    <div class="row">
      <div class="col-md-12">
        <ngx-datatable
        style="height: calc(55vh - 180px)"
        class="material striped"
        name="AggregationsTable"
        [columnMode]="'force'"
        [columns]="aggregationColumns"
        [count]="aggregationRows.length"
        [headerHeight]="50"
        [footerHeight]="false"
        [rowHeight]="30"
        [rows]="aggregationRows"
        [scrollbarV]="true"
        [loadingIndicator]="showSpinner"
        [virtualization]="false"

        ></ngx-datatable>
      </div>
    </div>
  </div>
  <!-- Exceptions -->
  <div *ngIf="tab_AEOrIgnored == 'ae'" class="detail-table-container">
    <h6 class="card-header">Exceptions</h6>
    <div class="row">
      <div class="col-md-12">
        <ngx-datatable
          style="height: calc(45vh - 166px)"
          class="material striped"
          name="ExceptionsTable"
          [columnMode]="'force'"
          [count]="exceptions.length"
          [headerHeight]="50"
          [footerHeight]="false"
          [rowHeight]="rowHeight"
          [rows]="exceptions"
          [scrollbarV]="true"
          [loadingIndicator]="showSpinner"
          [virtualization]="false"
          >

          <ngx-datatable-column
            *ngIf="showIgnoreColumn"
            [name]="'Ignore'"
            [width]="20"
            [resizeable]="false"
          >
            <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
              <i class="fa fa-trash-o"
                title="Ignore"
                (click)="HandleIgnoreRowClick(row, rowIndex)">
              </i>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            [name]="'Product Description'"
            [prop]="'prodDesc'"
            [width]="675">
          </ngx-datatable-column>

          <ngx-datatable-column
            [name]="'Count'"
            [prop]="'count'"
            [width]="100">
          </ngx-datatable-column>

        </ngx-datatable>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <button type="button" class="btn btn-primary" (click)="HandleIgnoreAllExceptionsClicked()" [disabled]="this.exceptions.length === 0">
          <i class="fa fa-trash-o" aria-hidden="true"></i> Clear All
        </button>
        <div class="float-right">
          <div *ngIf="status.toLowerCase()=='new'">
              <button type="button" name="btnResolutionComplete" class="btn btn-secondary" (click)="HandleResolution('complete')">Complete</button>
              <button type="button" name="btnResolutionRerun" class="btn btn-secondary" (click)="HandleResolution('rerun')">Rerun</button>
              <button type="button" name="btnResolutionRerun" class="btn btn-secondary" (click)="HandleResolution('reaggregate')">Re-Aggregate</button>
          </div>

          <div *ngIf="status.toLowerCase()=='completed' || status.toLowerCase()=='sent'">
              <button type="button" name="btnResolutionComplete" class="btn btn-secondary" (click)="UpdateAggregateResult(clientId, AggregationResultStatus.New)">Set to New</button>
          </div>
          
          <div *ngIf="status.toLowerCase()=='invoiced' && hasPermissionToEdit">
            <button type="button" name="btnResolutionReset" class="btn btn-secondary" (click)="UpdateAggregateResult(clientId, AggregationResultStatus.Completed)">Set to Completed</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Ignored Exceptions -->
  <div *ngIf="tab_AEOrIgnored == 'ignored'" class="detail-table-container">
    <div class="row">
      <div class="col-md-12">
        <ngx-datatable
          style="height: calc(100vh - 258px)"
          class="material striped"
          name="ignoredExceptionsTable"
          [columnMode]="'force'"
          [count]="ignoredExceptions.length"
          [headerHeight]="50"
          [footerHeight]="false"
          [rowHeight]="rowHeight"
          [rows]="ignoredExceptions"
          [scrollbarV]="true"
          [loadingIndicator]="showSpinner"
          [virtualization]="false"
          >

          <ngx-datatable-column
            *ngIf="showIgnoreColumn"
            [name]="'Ignore'"
            [width]="20"
            [resizeable]="false"
          >
            <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
              <i class="fa fa-trash-o"
                title="Ignore"
                (click)="HandleUnignoreRowClick(row, rowIndex)">
              </i>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            [name]="'Product Description'"
            [prop]="'prodDesc'"
            [width]="675">
          </ngx-datatable-column>

          <ngx-datatable-column
            [name]="'Count'"
            [prop]="'count'"
            [width]="100">
          </ngx-datatable-column>

        </ngx-datatable>
      </div>
    </div>
    <div class="row">
        <div class="col-md-12">
          <div class="float-right">
            <div *ngIf="status.toLowerCase()=='new'">
                <button type="button" name="btnResolutionComplete" class="btn btn-secondary" (click)="HandleResolution('complete')">Complete</button>
                <button type="button" name="btnResolutionRerun" class="btn btn-secondary" (click)="HandleResolution('rerun')">Rerun</button>
                <button type="button" name="btnResolutionRerun" class="btn btn-secondary" (click)="HandleResolution('reaggregate')">Re-Aggregate</button>
            </div>

            <div *ngIf="status.toLowerCase()=='completed' || status.toLowerCase()=='sent'">
                <button type="button" name="btnResolutionComplete" class="btn btn-secondary" (click)="UpdateAggregateResult(clientId, AggregationResultStatus.New)">Set to New</button>
            </div>

            <div *ngIf="status.toLowerCase()=='invoiced' && hasPermissionToEdit">
              <button type="button" name="btnResolutionReset" class="btn btn-secondary" (click)="UpdateAggregateResult(clientId, AggregationResultStatus.Completed)">Set to Completed</button>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
